module.exports = __webpack_public_path__ + "img/ht.e9a8420.webp";